var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-circle",class:{active: _vm.active}},[_c('canvas',{ref:"canvas"}),_c('img',{ref:"loadCircle",attrs:{"src":_vm.load,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }